import { pxToRem } from '../../../../utils';
import getBorderFocusStyles from '../../getBorderFocusStyles';
import { hierarchicalTreeTitleClassName } from '../../../../components/HierarchicalTree/HierarchicalTreeTitle';
var hierarchicalTreeItemStyles = {
  root: function root(_ref) {
    var _focusVisible;

    var siteVariables = _ref.theme.siteVariables;
    return Object.assign({
      listStyleType: 'none',
      padding: "0 0 0 " + pxToRem(1)
    }, getBorderFocusStyles({
      variables: siteVariables
    })[':focus'], {
      ':focus-visible': (_focusVisible = {}, _focusVisible["> ." + hierarchicalTreeTitleClassName] = Object.assign({
        position: 'relative'
      }, getBorderFocusStyles({
        variables: siteVariables
      })[':focus-visible']), _focusVisible)
    });
  }
};
export default hierarchicalTreeItemStyles;
//# sourceMappingURL=hierarchicalTreeItemStyles.js.map
